import querystring from 'query-string'
import { setJwt, setUser } from '../Store/AuthenticationSlice'
import { type RootState, store } from '../Store/Store'
import { subscribe } from '../Store/State'
import * as jwt from 'jsonwebtoken'

const lsJwtKey = 'jwt'

export function orchestrateAuthentication() {
  subscribe(
    (state: RootState) => state.authentication.jwt,
    (token) => {
      if (token != null) {
        const decodedToken = jwt.decode(token) as jwt.JwtPayload
        const exp = (decodedToken?.exp ?? 0) * 1000
        if (exp >= Date.now()) {
          localStorage.setItem(lsJwtKey, token)
          store.dispatch(
            setUser({
              email: decodedToken.email,
              isAdmin: decodedToken.isAdmin,
              certificateInstanceVatNumber:
                decodedToken.certificateInstanceVatNumber,
            })
          )
        } else {
          store.dispatch(setJwt(undefined))
        }
      } else {
        localStorage.removeItem(lsJwtKey)
      }
    }
  )

  const queryParameters = querystring.parse(window.location.search)
  const queryJwt = queryParameters.jwt as string | undefined
  if (queryJwt != null) {
    store.dispatch(setJwt(queryJwt))
  } else {
    const lsJwt = localStorage.getItem(lsJwtKey)
    if (lsJwt != null) store.dispatch(setJwt(lsJwt))
  }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function getAuthorizationHeader(): { authorization: string } | {} {
  const token = store.getState().authentication.jwt
  return token != null ? { authorization: `Bearer ${token}` } : {}
}
